<template>
  <div>
    <b-modal :id="modalId" title="Import" class="theme-modal" size="lg" @hidden="reset">

      <!-- Field Require -->
      <div>
        <h4 class="col-form-label">
          Field Require :
          <span style="float: right">
            <b-badge href="#" @click="downloadTemplate" pill variant="primary" style="cursor: pointer;">
              <span>Download Template</span>
            </b-badge>
          </span>
        </h4>
      </div>
      <div class="col">
        <div class="d-inline p-1" v-for="field in fields" :key="field.key">
          <b-badge pill variant="light"   v-if="field.isFind == null">{{ field.key }}</b-badge>
          <b-badge pill variant="danger"  v-if="field.isFind == false">{{ field.key }}</b-badge>
          <b-badge pill variant="success" v-if="field.isFind == true">{{ field.key }}</b-badge>
        </div>
      </div>

      <!-- Upload File -->
      <h4 class="col-form-label">Upload File :</h4>
      <div class="col">
        <div class="row theme-form">
          <div class="col">
            <div class="form-group">
              <input
                ref="fileInput"
                class="form-control"
                type="file"
                accept=".json"
                @change="onFileChange"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Error -->
      <div class="col" v-if="errorMsg">
        <p class="text-danger">
          <i class="icofont icofont-warning-alt mr-1"></i>{{ errorMsg }}
        </p>
      </div>

      <template #modal-footer>
        <b-button variant="primary" :disabled="!parsedData" @click="onImport">
          <i class="icofont icofont-download-alt"></i> Import
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ImportJsonModal',
  props: {
    modalId: {
      type: String,
      default: 'modal-import-json',
    },
    templateData: {
      type: Object,
      required: true,
    },
    templateFileName: {
      type: String,
      default: 'template.json',
    },
    requiredFields: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fields: [],
      parsedData: null,
      errorMsg: '',
    }
  },
  watch: {
    requiredFields: {
      immediate: true,
      handler(val) {
        this.fields = val.map(f => ({ ...f, isFind: null }))
      },
    },
  },
  methods: {
    downloadTemplate() {
      const blob = new Blob([JSON.stringify(this.templateData, null, 2)], { type: 'application/json' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = this.templateFileName
      a.click()
      URL.revokeObjectURL(url)
    },
    onFileChange(e) {
      this.parsedData = null
      this.errorMsg = ''
      this.fields.forEach(f => { f.isFind = null })

      const file = e.target.files[0]
      if (!file) return

      const reader = new FileReader()
      reader.onload = (ev) => {
        try {
          const data = JSON.parse(ev.target.result)

          // validate each required field (dot-notation path → must be Array)
          this.fields.forEach(f => {
            const val = f.key.split('.').reduce((o, k) => o?.[k], data)
            f.isFind = Array.isArray(val)
          })

          if (this.fields.some(f => f.isFind === false)) {
            this.errorMsg = 'โครงสร้างไฟล์ไม่ถูกต้อง กรุณาใช้ Template ที่ให้ไว้'
            return
          }

          this.parsedData = data
        } catch {
          this.errorMsg = 'ไฟล์ไม่ใช่ JSON ที่ถูกต้อง'
        }
      }
      reader.readAsText(file)
    },
    onImport() {
      if (!this.parsedData) return
      this.$emit('imported', this.parsedData)
      this.$bvModal.hide(this.modalId)
    },
    reset() {
      this.parsedData = null
      this.errorMsg = ''
      this.fields.forEach(f => { f.isFind = null })
      if (this.$refs.fileInput) this.$refs.fileInput.value = ''
    },
  },
}
</script>
